"use strict";
exports.__esModule = true;
exports.AlertingTeams = void 0;
var AlertingTeams;
(function (AlertingTeams) {
    AlertingTeams["Trading"] = "trading";
    AlertingTeams["Payroll"] = "payroll";
    AlertingTeams["MoneyIn"] = "moneyIn";
    AlertingTeams["MoneyOut"] = "moneyOut";
})(AlertingTeams = exports.AlertingTeams || (exports.AlertingTeams = {}));
